<template>
    <ul class="group">
        <li v-for="option in options" :key="option.value">
            <input type="checkbox" :id="option.value" :checked="value.includes(option.value)" @input="e => selectValue(option.value, e)" />
            <label :for="option.value">{{ option.label }}</label>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    methods: {
        selectValue(value, e) {
            const res = [...this.value];
            if (e.target.checked) {
                res.push(value);
            } else {
                res.splice(res.findIndex(item => item === value), 1);
            }
            this.$emit("input", res);
        }
    }
};
</script>
<style lang="scss" scoped>
.group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
        grid-row-gap: 4px;
    }

    label {
        text-transform: uppercase;
        font-weight: bold;
        margin-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// checkbox-group.vue?39bba656